import { render, staticRenderFns } from "./AgregarContacto.vue?vue&type=template&id=39522c18"
import script from "./AgregarContacto.vue?vue&type=script&lang=js"
export * from "./AgregarContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports